/**
 * 树表格布局
 */
import React, { Component } from "react";
import "./TreeAndTableLayout.css";
import CmTable from "../CmTable/CmTable";
import CmTree from "../CmTree/CmTree";
import PropTypes from 'prop-types';

export default class   TreeAndTableLayout extends Component {

    render() {
        let {
            showTree = true,
            selectedKeys,
            treeData,
            columns,
            searchType,
            ToolBar,
            onSearchValueChange,
            onSelect,
            tableData,
            showSearch,
            current,
            pageSize,
            onChange,
            onShowSizeChange,
            count,
            tableIsLoading,
            rowSelection,
            showRowSelection,
            expandedKeys,
            autoExpandParent,
            onExpand,
            showIcon,
            showTreeOperation,
            onTreeAdd,
            onTreeEdit,
            onTreeDelete,
            defaultLayout,
            isParamsConfig,
            isShowAddOperate
        } = this.props;
        return (
            <div id="TreeAndTableLayout">
                {showTree ? <div className="TreeAndTableLayout-left">
                    <CmTree
                        onSelect={onSelect}
                        showSearch={showSearch}
                        treeData={treeData}
                        selectedKeys={selectedKeys}
                        expandedKeys={expandedKeys}
                        autoExpandParent={autoExpandParent}
                        onExpand={onExpand}
                        showIcon={showIcon}
                        showTreeOperation={showTreeOperation}
                        onTreeAdd={onTreeAdd}
                        onTreeEdit={onTreeEdit}
                        onTreeDelete={onTreeDelete}
                        isShowAddOperate={isShowAddOperate}
                    />
                </div> : <></>}
                {
                   defaultLayout=="userDeptTree"?<div className="TreeAndTableLayout-right">
                        <CmTable
                            ToolBar={ToolBar}
                            searchType={searchType}
                            onSearchValueChange={onSearchValueChange}
                            columns={columns}
                            tableData={tableData}
                            current={current}
                            pageSize={pageSize}
                            onChange={onChange}
                            onShowSizeChange={onShowSizeChange}
                            count={count}
                            tableIsLoading={tableIsLoading}
                            rowSelection={rowSelection}
                            showRowSelection={showRowSelection}
                            isParamsConfig={isParamsConfig}
                        />
                    </div>
                    :null
                }
            </div>
        );
    }

    static propTypes = {
        // 展示左侧树节点
        showTree: PropTypes.bool,
        // 
        selectedKeys: PropTypes.array,
        treeData: PropTypes.array,
        columns: PropTypes.array,
    }

    static defaultProps = {
        showTree: true,
        selectedKeys:[],
        treeData:[],
        columns:[],
        onSearchValueChange(){},
        // 树点击时的回调
        onSelect(){},
        // 当前表格数据
        tableData: [],
        // 展示树的搜索功能
        showSearch: false,
        // 当前页码
        current: 1,
        // 表格每页的大小
        pageSize: 10,
        // 表格页码变化回调
        onChange() { },
        // 表格每页大小变化回调
        onShowSizeChange() { },
        // 表格的总数
        count: 0,
        // 显示表格正在加载
        tableIsLoading: false,
        // 展示表格复选框
        showRowSelection: false,
        // 展开的节点key
        expandedKeys: [],
        // 节点展开的回调
        onExpand() { },
        // 是否显示节点前面小按钮
        showIcon: false,
        // 是否展示操作按钮
        showTreeOperation: false,
        // 树节点 点击添加
        onTreeAdd() { },
        // 树节点 点击添加
        onTreeEdit() { },
        // 树节点 点击添加
        onTreeDelete() { },
        defaultLayout:'userDeptTree'
    }
}

